import {
  ADD_TO_CART,
  REMOVE_ITEM,
  SUB_QUANTITY,
  ADD_QUANTITY,
  ADD_SHIPPING,
  SUB_SHIPPING,
  DELETE_CART,
  UPDATE_ITEM_STATUS
} from "../actions/action-types/cart-actions";

import { getLocalStorage, setLocalStorage, deleteLocalStorage } from '../../utils/LocalStorageUtils';
import { parseInteger } from '../../utils/ParseInteger';
import {
  handleItemName
} from '../../utils/Orders';

const orderStatus = {
  NEW: '___NEW',
  PLACED: '___PLACED',
  ACCEPTED: '___ACCEPTED',
  PREPARING: '___PREPARING',
  READY: '___READY',
  COMPLETED: '___COMPLETED',
};

const initState = getLocalStorage('scart_state') || {
  /*items: [],*/
  addedItems: [],
  total: 0,
  deliveryCharge: getLocalStorage('shopDeliverCharges') || 10,
  shopDetails: {
    shopName : getLocalStorage('shopName') || '',
    shopStatus : getLocalStorage('shopStatus') || '',
    shopType : getLocalStorage('shopType') || '',
    shopPhoneNumber : getLocalStorage('phoneNumber') || '',
    shopGST : getLocalStorage('shopGST') || '',
    shopId: getLocalStorage('shopId') || '',
  },
};

const deleteState = () => {
  deleteLocalStorage('scart_state');
  deleteLocalStorage('optDelivery');
}

const cartReducer = (state = initState, action) => {
  const isOffline = getLocalStorage('offlineMode');

  // select price based on mode

  if (isOffline === false && action.id) {
    action.id.price = action.id.onlinePrice;
  }

  const emptyState = {
    ...state,
    addedItems: [],
    deliveryCharge: "",
    shopDetails: {
      shopName: "",
      shopStatus: "",
      shopType: "",
      shopPhoneNumber: "",
      shopGST: "",
      shopId: "",
    },
    total: 0,
  };

  //INSIDE HOME COMPONENT
  switch (action.type) {
    case DELETE_CART: {
      deleteState();
      return emptyState;
    }
    case ADD_TO_CART: {

      if (state.shopDetails.shopId === '') {
        state.shopDetails.shopId = getLocalStorage('shopId') || '';
      }

      if (state.shopDetails.shopName === "") {
        state.shopDetails.shopName = getLocalStorage('shopName');
      }

      if (state.shopDetails.shopType === "") {
        state.shopDetails.shopType = getLocalStorage('shopType');
      }

      if (state.shopDetails.shopStatus === "") {
        state.shopDetails.shopStatus = getLocalStorage('shopStatus');
      }

      if (state.shopDetails.shopGST === "") {
        state.shopDetails.shopGST = getLocalStorage('shopGST');
      }

      if (state.shopDetails.shopPhoneNumber === "") {
        state.shopDetails.shopPhoneNumber = getLocalStorage('shopPhoneNumber');
      }

      if (state.deliveryCharge === "") {
        state.deliveryCharge = getLocalStorage('shopDeliverCharges') || 10;
      }

      //let addedItem = state.items.find(item=> item.id === action.id);
      let addedItem = action.id;

      //check if the action id exists in the addedItems
      let existed_item = state.addedItems.find(
        (item) => action.id.item === item.item
      );

      if (existed_item) {
        //addedItem.quantity += 1;
        state.addedItems.find((item) => {
          if (action.id.item === item.item) {
            item.quantity += 1;
          }
          return false;
        });

        const cartState = {
          ...state,
          addedItems: [...state.addedItems],
          total: parseInteger(state.total) + parseInteger(addedItem.price),
        };

        setLocalStorage('scart_state', cartState);

        return {
          ...state,
          addedItems: [...state.addedItems],
          total: parseInteger(state.total) + parseInteger(addedItem.price),
        };

      } else {
        addedItem.quantity = 1;
        if (isOffline === 'OK') {
          addedItem.itemId = Date.now();
        }
        //calculating the total
        let newTotal = parseInteger(state.total) + parseInt(addedItem.price);

        const cartState = {
          ...state,
          addedItems: [...state.addedItems, addedItem],
          total: newTotal,
        };

        setLocalStorage('scart_state', cartState);

        return {
          ...state,
          addedItems: [...state.addedItems, addedItem],
          total: newTotal,
        };
      }
    }
    case REMOVE_ITEM: {
      let itemToRemove = state.addedItems.find((item) => action.id.item === item.item);
      let new_items = state.addedItems.filter((item) => action.id.item !== item.item);

      //calculating the total
      let newTotal =
        state.total -
        parseInteger(itemToRemove.price) * parseInteger(itemToRemove.quantity);

      if (newTotal <= 0) {
        deleteState();
        return emptyState;
      } else {
        const cartState = {
          ...state,
          addedItems: new_items,
          total: newTotal,
        };

        setLocalStorage('scart_state', cartState);
      }

      return {
        ...state,
        addedItems: new_items,
        total: newTotal,
      };
    }
    case ADD_QUANTITY: {
      //INSIDE CART COMPONENT
      //console.log(action.id);
      let addedItem = state.addedItems.find((item) => item.item === action.id.item);
      addedItem.quantity += 1;
      let newTotal = parseInteger(state.total) + parseInteger(addedItem.price);

      const cartState = {
        ...state,
        addedItems: [...state.addedItems],
        total: newTotal,
      };

      setLocalStorage('scart_state', cartState);
      return {
        ...state,
        addedItems: [...state.addedItems],
        total: newTotal,
      };
    }
    case SUB_QUANTITY: {
      //console.log(state.addedItems);
      let addedItem = state.addedItems.find((item) => item.item === action.id.item);
      //if the qt == 0 then it should be removed
      if (addedItem.quantity === 1) {
        let new_items = state.addedItems.filter((item) => item.item !== action.id.item);
        let newTotal = parseInteger(state.total) - parseInteger(addedItem.price);

        if (newTotal <= 0) {
          deleteState();
          return emptyState;
        } else {
          const cartState = {
            ...state,
            addedItems: new_items,
            total: newTotal,
          };

          setLocalStorage('scart_state', cartState);
        }

        return {
          ...state,
          addedItems: new_items,
          total: newTotal,
        };
      } else {
        addedItem.quantity -= 1;
        let newTotal = parseInteger(state.total) - parseInteger(addedItem.price);

        if (newTotal <= 0) {
          deleteState();
          return emptyState;
        } else {
          const cartState = {
            ...state,
            addedItems: [...state.addedItems],
            total: newTotal,
          };

          setLocalStorage('scart_state', cartState);
        }

        return {
          ...state,
          addedItems: [...state.addedItems],
          total: newTotal,
        };
      }
    }
    case ADD_SHIPPING: {
      //let addedItem = state.addedItems[0];
      let totalWithDelivery =
        parseInteger(state.total) + parseInteger(state.deliveryCharge);

      const cartState = {
        ...state,
        total: totalWithDelivery,
      };

      setLocalStorage('scart_state', cartState);
      return {
        ...state,
        total: totalWithDelivery,
      };
    }
    case SUB_SHIPPING: {
      //let addedItem = state.addedItems[0];
      let totalWithDelivery =
        parseInteger(state.total) - parseInteger(state.deliveryCharge);

      const cartState = {
        ...state,
        total: totalWithDelivery,
        //total: state.total - 6
      };

      setLocalStorage('scart_state', cartState);
      return {
        ...state,
        total: totalWithDelivery,
        //total: state.total - 6
      };
    }
    case UPDATE_ITEM_STATUS: {
      // this is only for offline orders
      if (isOffline !== 'OK') {
        return {
          ...state,
        };
      }

      /*let addedItem = action.id;*/
      let itemStatus = action.status;

      //check if the action id exists in the addedItems
      let existed_item = state.addedItems.find(
        (item) => action.id.item === handleItemName(item.item) && action.id.itemId === item.itemId
      );

      if (existed_item) {
        //addedItem.quantity += 1;
        state.addedItems.find((item) => {
          if (
            action.id.item === handleItemName(item.item)
            && action.id.itemId === item.itemId
          ) {
            item.itemStatus = itemStatus;
            //item.item = item.item + ' ✔';//String.fromCharCode(2714);
            item.item = handleItemName(item.item) + orderStatus[itemStatus];
          }
          return false;
        });

        const cartState = {
          ...state,
          addedItems: [...state.addedItems],
        };

        setLocalStorage('scart_state', cartState);

        return {
          ...state,
          addedItems: [...state.addedItems],
        };

      } else  {
        return {
          ...state,
        };
      }
    }
    default: {
      return state;
    }
  }

};

export default cartReducer;
